import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { LineChart, LiveDot } from "@/ui";
import { overviewConversions, overviewVisitors, signalsKpis, useLiveVisitors } from "@/mock";
import { formatKpi } from "@/lib/format";
import { useTheme } from "@/theme/ThemeProvider";

/**
 * Present mode — a fullscreen Signals "moment" for a TV or team standup. Forces
 * the ink skin (design.md sanctioned dark moment), no chrome.
 */
export function PresentScreen() {
  const nav = useNavigate();
  const { setPresent } = useTheme();
  const { count } = useLiveVisitors();

  useEffect(() => {
    setPresent(true);
    return () => setPresent(false);
  }, [setPresent]);

  return (
    <div className="min-h-screen bg-canvas px-6 py-8 md:px-16 md:py-14">
      <div className="mx-auto max-w-6xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="h-3 w-3 rounded-full bg-accent" />
            <span className="text-[18px] font-semibold tracking-tight text-ink-strong">aigen Studio · live</span>
          </div>
          <div className="flex items-center gap-4">
            <LiveDot label={`${count} now`} />
            <button onClick={() => nav("/signals")} aria-label="Exit present" className="grid h-10 w-10 place-items-center rounded-full border border-hairline text-muted hover:text-ink">
              <X className="h-5 w-5" strokeWidth={1.5} />
            </button>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-6 md:grid-cols-4">
          {signalsKpis.map((k) => (
            <div key={k.key}>
              <p className="eyebrow mb-2">{k.label}</p>
              <p className={`text-[40px] font-semibold tracking-tight md:text-[56px] ${k.focal ? "text-accent" : "text-ink-strong"}`}>
                {formatKpi(k.value, k.unit)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <LineChart a={overviewVisitors} b={overviewConversions} height={320} />
        </div>
      </div>
    </div>
  );
}
